import { Breakpoints, styled } from '@volkswagen-onehub/components-core';

interface StyledFooterProps {
  stacked?: boolean;
}
export const StyledFooter = styled.div<StyledFooterProps>(
  ({ theme, stacked }) => `
  display: flex;
  gap: ${theme.size.static150};
  flex-direction: column;

  @media(min-width: ${Breakpoints.b960}px) {
    flex-direction: ${stacked ? 'column' : 'row'};
    gap: ${stacked ? theme.size.static150 : theme.size.static300};
    align-items: ${stacked ? 'start' : 'center'};
    flex-wrap: wrap;
    justify-content: space-between;
  }
`
);

export const StyledLinks = styled.div(
  ({ theme }) => `
  display: flex;
  flex-direction: row;
  flex: 1;
  flex-wrap: wrap;
  justify-content: space-between;
  gap: ${theme.size.static150};

  @media(min-width: ${Breakpoints.b960}px) {
    flex: unset;
    gap: ${theme.size.static250};
  }
`
);
